import { useEffect, useRef } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { KeyUri } from "../key";
import { trackEvent } from "../utils/metaPixel";
const CashfreePaymentStatus = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const hasRun = useRef(false);

  useEffect(() => {
    if (hasRun.current) return;
    hasRun.current = true;
    const verifyPayment = async () => {
      try {
        const orderId = searchParams.get("order_id");

        if (!orderId) {
          navigate("/", {
            replace: true,
            state: {
              toastType: "error",
              toastMessage: "Invalid payment response",
            },
          });
          return;
        }

        const response = await axios.post(
          `${KeyUri.BACKEND_URI}/wellness-booking/cashfree/verify`,
          { orderId }
        );
        if (response.data?.success) {
          const booking = response.data.booking;
          const bookingId = booking?._id;
          const bookingReference = booking?.bookingReference;

          // Meta Pixel: Purchase - read back stashed values, fall back to booking.eventId
          const eventId = sessionStorage.getItem("cashfree_wellness_event_id");
          const value = sessionStorage.getItem("cashfree_wellness_value") || booking?.amountPaid;
          const packageId = sessionStorage.getItem("cashfree_wellness_package_id") || booking?.packageId;

          trackEvent("Purchase", {
            value: Number(value || 0),
            currency: "INR",
            content_ids: [packageId],
            content_type: "wellness_package",
            content_name: booking?.packageTitle || "Wellness Booking",
          }, eventId || booking?.eventId);

          sessionStorage.removeItem("cashfree_wellness_event_id");
          sessionStorage.removeItem("cashfree_wellness_value");
          sessionStorage.removeItem("cashfree_wellness_package_id");

          alert(
            booking.paymentType === "partial"
              ? `Advance payment successful! Your booking reference is ${
                  bookingReference || bookingId
                }. Remaining amount: ₹${(
                  booking.remainingAmount || 0
                ).toLocaleString("en-IN")}`
              : `Booking confirmed successfully! Your booking reference is ${
                  bookingReference || bookingId
                }`
          );

          navigate(`/wellness-invoice?bookingId=${bookingId}`);
        } else {
          alert(
            response.data?.message ||
            "Payment failed or was not completed."
          );

          navigate("/");
        }
      } catch (error) {
        console.error(error);

        alert(
          error?.response?.data?.message ||
          "Payment verification failed."
        );

        navigate("/");
      }
    };

    verifyPayment();
  }, []);

  return null;
};

export default CashfreePaymentStatus;